import {Apollo, gql} from 'apollo-angular';
import { Component, OnInit, ViewChild } from '@angular/core';

import { EventService } from '../../../core/services/event.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ImageModalComponent } from '../../../core/components/dialogs/image-modal/image-modal.component';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgressService } from '../../../core/services/progress.service';
import { AuthenticationService } from '../../../authentication/authentication.service';

import { ImageService } from '../../../core/services/image.service';
import {map} from "rxjs/operators";
//import {CKEditorComponent} from "ng2-ckeditor/ckeditor.component";

@Component({
  selector: 'app-edit-news-feed',
  templateUrl: './edit-news-feed.html',
  styleUrls: ['./edit-news-feed.scss']
})
export class EditNewsFeedComponent implements OnInit {
  @ViewChild('newsFeedEditor') newsFeedEditor: any;

  newsFeed: any = {};
  isMobile: boolean;
  ckeditorConfigMobile = {
    uiColor: '#e4e9f0',
    extraPlugins: 'resize,divarea',
    clipboard_handleImages: false, //don't allow drag and drop base64 images to be added to posts
    removeButtons: 'Underline,JustifyCenter',
    removePlugins: 'a11yhelp,about,bidi,blockquote,' +
      'colorbutton,colordialog,dialogadvtab,div,elementspath,enterkey,entities,popup,filebrowser,' +
      'find,flash,floatingspace,format,forms,horizontalrule,htmlwriter,iframe,' +
      'indent,indentblock,indentlist,list,liststyle,magicline,maximize,newpage,pagebreak,pastefromword,removeformat,' +
      'save,scayt,selectall,showblocks,showborders,smiley,specialchar,stylescombo,tab,' +
      'templates,' +
      'image,', //conflicts with image2
    allowedContent: true,
    resize_enabled: true,
    height: 300,
    removeDialogTabs: 'link:target; link:advanced',
    readOnly: this.eventService.selectedEvent.isPastEvent,
    toolbar: [
      { name: 'buttons', items: [ 'Undo', 'Redo', 'Bold', 'Italic', 'CopyFormatting', 'JustifyLeft', 'JustifyCenter',
          'JustifyRight', 'JustifyBlock', 'image', 'VideoEmbed', 'Font', 'FontSize'] },
    ]
  };
  ckeditorConfig = {
    uiColor: '#e4e9f0',
    extraPlugins: 'resize,divarea',
    clipboard_handleImages: false, //don't allow drag and drop base64 images to be added to posts
    removeButtons: 'Underline,JustifyCenter',
    removePlugins: 'a11yhelp,about,bidi,blockquote,' +
      'colorbutton,colordialog,dialogadvtab,div,elementspath,enterkey,entities,popup,filebrowser,' +
      'find,flash,floatingspace,format,forms,horizontalrule,htmlwriter,iframe,' +
      'indent,indentblock,indentlist,list,liststyle,magicline,maximize,newpage,pagebreak,pastefromword,removeformat,' +
      'save,scayt,selectall,showblocks,showborders,smiley,specialchar,stylescombo,tab,' +
      'templates,' +
      'image,', //conflicts with image2
    allowedContent: true,
    resize_enabled: true,
    height: 300,
    removeDialogTabs: 'link:target;link:advanced',
    readOnly: this.eventService.selectedEvent.isPastEvent,
    toolbar: [
      { name: 'buttons', items: [ 'Source', 'Preview', 'Print', 'Cut',
          'Copy', 'Paste', 'PasteFromWord', 'Undo', 'Redo', 'Bold', 'Italic', 'CopyFormatting', 'JustifyLeft', 'JustifyCenter',
          'JustifyRight', 'JustifyBlock', 'image', 'VideoEmbed', 'Table', 'Font', 'FontSize'] },
    ]
  };

  constructor(
    public eventService: EventService,
    public route: ActivatedRoute,
    private http: HttpClient,
    private ToastrService: ToastrService,
    public modalService: NgbModal,
    private apollo: Apollo,
    private progressService: ProgressService,
    private authService: AuthenticationService,
    private imageService: ImageService
  ) {
  }

  isTeamGql() {
    return this.route.snapshot.queryParams['isTeam'] && this.eventService.selectedEvent.gql.Participant[0].team;
  }

  isParticipantGql() {
    return !this.route.snapshot.queryParams['isTeam'] && this.eventService.selectedEvent.gql.Participant;
  }

  ngOnInit() {
    this.initializeNewsFeed();
  }

  openImageExplorer() {
    const imageModal = this.modalService.open(ImageModalComponent); // open pop-up window
    imageModal.result.then(result => {
      this.newsFeedEditor.instance.insertHtml(
        '<img src=\'' + result.imagePath + '\'/>');
    }, () => {/* avoids error on 'cancel' */
    });
  }

  private initializeNewsFeed() {
    if (this.isTeamGql()) {
      this.newsFeed = this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserNewsFeeds[0] || {};
    } else if (this.isParticipantGql()) {
      this.newsFeed = this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserNewsFeeds[0] || {};
    } else {
      // Should not happen
    }

    var baseUrl = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.baseUrl;
    if (this.newsFeed['htmlContent']) {
      this.newsFeed.htmlContent = this.newsFeed.htmlContent.replace(this.imageService.getUpdateImageRegex(''), '$1' + baseUrl + '$3');
    }

    //TODO: may want to update this
    if (window.innerWidth < 767) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  save() {

    var baseUrl = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.baseUrl
    var htmlContent = this.newsFeed.htmlContent.replace(this.imageService.getUpdateImageRegex(baseUrl), '$1' + '$3');

    const payload = {
      newsFeedID: this.newsFeed.fundraiserNewsFeedId,
      htmlContent: htmlContent
    };

    if (this.newsFeed.fundraiserNewsFeedId) {
      this.http.post('/api/v1/feeds/' + this.newsFeed.fundraiserNewsFeedId, payload).subscribe(() => {
        this.ToastrService.success('News feed updated.');
        this.reloadNewsFeed();
      }, err => {
        this.ToastrService.error('There was problem saving your news feed.');
      });
    } else {
      this.http.post('/api/v1/pages/' + this.route.snapshot.params['pageID'] + '/feeds', payload).subscribe(() => {
        this.ToastrService.success('News feed created.');
        this.reloadNewsFeed();
      }, err => {
        this.ToastrService.error('There was problem saving your news feed.');
      });
    }
  }

  // Reloads the news feed section from GraphQL
  reloadNewsFeed() {
    this.progressService.startProgress(false);
    var isTeam = !!this.route.snapshot.queryParams['isTeam'];
    var partialQuery;
    if (isTeam) {
      let teamId = this.eventService.selectedEvent.gql.Participant[0].team.teamId;
      partialQuery = `Team (teamId: ${ teamId }) {
                fundraiser {
                  fundraiserNewsFeeds {
                     htmlContent
                     fundraiserNewsFeedId
                  }
                }
              }`;
    } else {
      let individualConstituentId = this.authService.user.constituentID,
        participantId = this.eventService.selectedEvent.participantId;
      partialQuery = `Participant(participantId: ${ participantId }) {
                        participantId
                        individualConstituent {
                          individualConstituentId
                        }
                        event {
                          eventId
                        }
                        fundraiser {
                          fundraiserNewsFeeds {
                             htmlContent
                             fundraiserNewsFeedId
                          }
                        }
                      }`;
    }
    var query = gql`
                  query EventRelatedQuery {
                    ${ partialQuery }
                  }`;

    this.apollo.query<any>({
      fetchPolicy: 'network-only',
      query: query
    }).pipe(map(res => {
      let data = JSON.parse(JSON.stringify(res.data));

      if (isTeam) {
        this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraiserNewsFeeds = data.Team[0].fundraiser.fundraiserNewsFeeds;
      } else {
        this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserNewsFeeds = data.Participant[0].fundraiser.fundraiserNewsFeeds;
      }
      this.initializeNewsFeed();
      this.progressService.stopProgress(false);

      return res.data;
    })).subscribe();
  }
}
